import axios from 'axios'

// Ringkasan stok hampir/habis untuk banner di halaman Faktur Penjualan & POS.
export const getLowStockSummary = (params, config) =>
  axios.get('/finance/products/lowStockSummary', { params, ...config })
